import { NgModule } from '@angular/core';

import {SharedModule} from "../../shared/shared.module";
import {SituacaoApiService} from "./situacao-api.service";

@NgModule({
  imports: [
    SharedModule
  ],
  providers:[
    SituacaoApiService
  ],
  declarations: []
})
export class SituacoesModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/situacoes/situacoes.module.ts
 **/